module.exports = __webpack_public_path__ + "static/img/hang_xian_manage.d9a55b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/hang_xian_manage.png
// module id = iFHD
// module chunks = 2